import keyMirror from 'keymirror';

const types = keyMirror({
  //payment type
	REFRESH_PAYMENT_TYPE_LIST: null,
	UPDATE_PAYMENT_TYPE_NAME: null,
  DELETE_PAYMENT_TYPE: null,
  ADD_PAYMENT_TYPE: null,
  //payment
  REFRESH_PAYMENT_LIST: null,
	UPDATE_PAYMENT: null,
  DELETE_PAYMENT: null,
  ADD_PAYMENT: null,
  UPDATE_TOTAL_PRICE: null,
});

export default types;



// WEBPACK FOOTER //
// ./src/constants/PaymentConstants.js